import { createTheme } from '@mui/material/styles';

export const gasTheme = createTheme({
  palette: {
    mode: 'dark', primary: { main: '#16E2F5', contrastText: '#081A35' }, secondary: { main: '#178FFF' },
    background: { default: '#081A35', paper: '#102746' }, text: { primary: '#F0F7FF', secondary: '#AFC0D8' },
    divider: 'rgba(140, 195, 240, .2)', success: { main: '#6DE5BC' }, warning: { main: '#FFD18A' }, error: { main: '#FFACAC' },
  },
  typography: { fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', button: { textTransform: 'none', fontWeight: 600 } },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { minHeight: 44 }, sizeSmall: { minHeight: 36 } } },
    MuiIconButton: { styleOverrides: { root: { minWidth: 44, minHeight: 44 } } },
    MuiOutlinedInput: { styleOverrides: { root: { background: 'rgba(255,255,255,.035)' } } },
    MuiTableCell: { styleOverrides: { root: { borderColor: 'rgba(140,195,240,.17)', color: '#F0F7FF' }, head: { color: '#AFC0D8', fontWeight: 600 } } },
    MuiDialog: { styleOverrides: { paper: { backgroundImage: 'none', backgroundColor: '#102746' } } },
    MuiMenu: { styleOverrides: { paper: { backgroundImage: 'none', backgroundColor: '#102746', color: '#F0F7FF' } } },
  },
});
